module.exports = __webpack_public_path__ + "media/src/images/bg_halfCircle-95d5eec1eba7171fdb3bcea18e26bbab.png";